import React, {useState, useRef} from 'react';

const Switch = (props) => {
    const {
        name,
        rightLabel      = null,
        leftLabel       = null,
        value           = "",
        required        = false,
        checked         = null,
        defaultChecked  = null,
        onChange        = () => {},
        disabled        = false
    } = props;

    return (
        <div className="custom-control custom-switch">
            {!!leftLabel && (
                <label className="left-label user-select-none m-0" htmlFor={name}>
                    {leftLabel}
                </label>
            )}
            <input
                id={name}
                name={name}
                type="checkbox"
                className={"custom-control-input"}
                value={value}
                required={required}
                defaultChecked={defaultChecked}
                checked={checked}
                onChange={(event) => onChange(event)}
                disabled={disabled}
            />
            {!!rightLabel ? (
                <label className="custom-control-label right-label user-select-none" htmlFor={name}>
                    {rightLabel}
                </label>
            ) : (
                <label className="custom-control-label right-label no-right-label user-select-none" htmlFor={name}>
                    <span style={{color: "transparent"}}>X</span>
                </label>
            )}
        </div>
    )
}

export default Switch;
